export const SLIDE_OUT_STATUSES = [
  'isClosed',
  'isClosing',
  'isOpening',
  'isOpen',
] as const;

export const DEFAULT_WIDTH = '400px';

export const DEFAULT_SIDE = 'right';

// Duration of the slide-in/out animation.
export const ANIMATION_DURATION = 300;

// Extra time on the close fallback so `animationend` can fire before the timer.
export const BUFFER_DURATION = 50;
